var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirstinIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7567_4851)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    fill: "url(#paint0_linear_7567_4851)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_7567_4851)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.40799 5.06816C9.40799 4.9935 9.39866 4.9095 9.37999 4.83483C9.37066 4.56416 9.44532 4.1535 9.98666 4.1815C10.0707 4.2095 10.164 4.21883 10.2573 4.21883C10.78 4.21883 11.2 3.79883 11.2 3.27616C11.2 2.7535 10.7707 2.3335 10.248 2.3335C9.72533 2.3335 9.30532 2.7535 9.30532 3.27616C9.30532 3.3695 9.31466 3.4535 9.34266 3.5375C9.33332 3.7895 9.16532 4.1255 8.36266 4.1255H3.75199C3.22933 4.1255 2.80933 4.5455 2.80933 5.06816C2.80933 5.88016 3.47199 6.01083 3.47199 6.01083C3.73333 6.01083 3.94799 6.2255 3.94799 6.48683C3.94799 6.74816 3.73333 6.96283 3.47199 6.96283C3.47199 6.96283 2.80933 7.07483 2.80933 7.9055C2.80933 8.42816 3.22933 8.84816 3.75199 8.84816H6.57999C7.10266 8.84816 7.52266 8.42816 7.52266 7.9055C7.52266 7.38283 7.09333 6.9535 6.57999 6.9535H4.88133C4.61999 6.9535 4.40533 6.73883 4.40533 6.4775C4.40533 6.21616 4.61999 6.0015 4.88133 6.0015H8.46532C8.97866 6.01083 9.40799 5.59083 9.40799 5.06816ZM4.12533 9.7815C3.60266 9.7815 3.18266 10.2015 3.18266 10.7242C3.18266 11.2468 3.60266 11.6668 4.12533 11.6668C4.64799 11.6668 5.06799 11.2468 5.06799 10.7242C5.06799 10.2015 4.64799 9.7815 4.12533 9.7815Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7567_4851",
    x1: 14,
    y1: 1.49091e-8,
    x2: 5.69813,
    y2: 16.8135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B01BAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA3F85"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7567_4851"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_7567_4851"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.33333,
    height: 9.33333,
    fill: "white",
    transform: "translate(2.33333 2.3335)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstinIcon);
export default __webpack_public_path__ + "static/media/firstin-icon.8c69480aab80e0ef2549caec8b6eb03e.svg";
export { ForwardRef as ReactComponent };